module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['op--modal-container', {
      hide: !_vm.show
    }]
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "cancellation small-margin-v-s"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingFee && !_vm.done && !_vm.cancelling),
      expression: "!loadingFee && !done && !cancelling"
    }],
    staticClass: "fas fa-times-circle close-icon fa-2x",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingFee),
      expression: "loadingFee"
    }],
    staticClass: "loaderx"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-circle-notch fa-spin"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingFee),
      expression: "!loadingFee"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cancelling && !_vm.done),
      expression: "!cancelling && !done"
    }]
  }, [(_vm.showRefundCredit && _vm.refundToggle) ? _c('div', {
    staticClass: "credit-box"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('rsvpEdit.convertCredit')))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('rsvpEdit.convertDesc1')) + "\n                "), _c('b', [_vm._v("$" + _vm._s(_vm.total))]), _vm._v(" \n                " + _vm._s(_vm.$t('rsvpEdit.convertDesc2')) + "\n                " + _vm._s(_vm.$t('rsvpEdit.convertDesc3')) + "\n              ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('rsvpEdit.confirmConvert')))]), _vm._v(" "), _c('a', {
    staticClass: "op-btn btn-lg btn-block btn-danger",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.cancel(_vm.rsvpId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.yes')))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.declineCredit
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.no')))])]) : _c('div', {
    staticClass: "non-credit-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.confirmCancel')))]), _vm._v(" "), _c('div', {
    staticClass: "cancel-reason"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.whyCancel')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancellation.selectedReason),
      expression: "cancellation.selectedReason"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cancellation.selectedReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.chooseOne')))]), _vm._v(" "), _vm._l((_vm.cancellation.reasons), function(value, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(value))])
  })], 2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancellation.selectedReason === 11),
      expression: "cancellation.selectedReason === 11"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cancellation.customReason),
      expression: "cancellation.customReason"
    }],
    domProps: {
      "value": (_vm.cancellation.customReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cancellation.customReason = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isLyft) ? _c('div', {
    staticClass: "message lyft-error"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.cxlFeeWillApply')))]) : _vm._e(), _vm._v(" "), (!_vm.refundAsCredits) ? _c('div', {
    staticClass: "message margin-b-m",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancellation.showError),
      expression: "cancellation.showError"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.provideReason')))]), _vm._v(" "), _c('a', {
    staticClass: "op-btn btn-lg btn-block btn-danger",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.cancel(_vm.rsvpId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.yesCancel')))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.noCancel')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancelling),
      expression: "cancelling"
    }],
    staticClass: "loaderx"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-circle-notch fa-spin"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.cancelRsvp')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "loaderx"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }]
  }, [_c('div', {
    staticClass: "success-box margin-b-m"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-check-circle"
  }), _vm._v(" "), (_vm.refundAsCredits) ? _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('rsvpEdit.rsvp')) + "\n                  " + _vm._s(_vm.queue.success.length ? _vm.queue.success.join(', ') : _vm.rsvpId) + "\n                  " + _vm._s(_vm.$t('rsvpEdit.creditSuccess')) + "\n                ")]) : _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.cancelSuccess')))])]), _vm._v(" "), (_vm.rsvps.length) ? _c('div', {
    staticClass: "margin-b-s"
  }, [_c('div', {
    staticClass: "margin-b-s",
    staticStyle: {
      "line-height": "1.4"
    }
  }, [_vm._v("\n                  You have other active reservations in your account.\n                  "), _c('br'), _vm._v(" "), (_vm.refundAsCredits) ? _c('span', [_vm._v("Would you like to convert any of these reservations into ride credits?")]) : _c('span', [_vm._v("Would you like to cancel any of these reservations?")])]), _vm._v(" "), _c('div', {
    staticClass: "rsvp-box margin-b-m"
  }, _vm._l((_vm.rsvps), function(rsvp, i) {
    return _c('label', {
      key: i,
      staticClass: "rsvp-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox",
        "id": "asd"
      },
      domProps: {
        "value": rsvp.id,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, rsvp.id) > -1 : (_vm.selected)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = rsvp.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rsvp-info"
    }, [_c('b', [_vm._v("\n                        Res " + _vm._s(rsvp.id) + "\n                        "), (!_vm.refundAsCredits) ? _c('b', {
      staticClass: "margin-l-s"
    }, [_vm._v("(Cancel Fee: $" + _vm._s(rsvp.cancelFee) + ")")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(rsvp.pickupDate))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(rsvp.pickup) + "  >  " + _vm._s(rsvp.dropoff))])])])
  })), _vm._v(" "), _c('a', {
    class: ['op-btn btn-lg btn-block btn-danger margin-b-m', {
      disabled: !_vm.selected.length
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.initRsvpCxl
    }
  }, [(_vm.refundAsCredits) ? _c('span', [_vm._v("Yes, convert my selected reservations")]) : _c('span', [_vm._v("Yes, cancel my selected reservations")])]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("\n                  No, keep my other reservations\n                ")])]) : _c('a', {
    staticClass: "cancel-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.ok')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.success),
      expression: "!success"
    }]
  }, [_c('i', {
    staticClass: "fa fa-3x fa-times-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-t-xs"
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.oops')))]), _vm._v(" "), _c('a', {
    staticClass: "cancel-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('rsvpEdit.tryAgain')))])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1199ed0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1199ed0e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpEdit/CancelReservation.vue
// module id = 2037
// module chunks = 0